module.exports = __webpack_public_path__ + "img/ed5a99e.png";